export class HitEffect {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.life = 20;
    this.particles = Array.from({ length: 8 }, () => ({
      x,
      y,
      vx: (Math.random() - 0.5) * 4,
      vy: (Math.random() - 0.5) * 4,
      size: Math.random() * 4 + 2,
      color: `hsl(${Math.random() * 60 + 15}, 100%, 50%)`
    }));
  }

  update() {
    this.life--;
    this.particles.forEach(p => {
      p.x += p.vx;
      p.y += p.vy;
      p.size *= 0.9;
      p.vx *= 0.95;
      p.vy *= 0.95;
    });
  }

  draw(ctx) {
    this.particles.forEach(p => {
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    });
  }

  isDone() {
    return this.life <= 0;
  }
}

